import React from "react";
import {CircularProgress} from "@material-ui/core";

const styles = {
    color: "rgb(255, 0, 0)"
}

export default function Loading() {
    return(
        <div className="d-flex justify-content-center">
            <CircularProgress style={styles}/>
        </div>
    )
}